import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Layout
import { Layout } from "./components/layout/layout/layout";

// Features
import { Dashboard } from "./components/features/dashboard/Dashboard";
import ImpactAnalysis from "./components/features/impactAnalysis/ImpactAnalysis";
import Bottlers from "./components/features/bottlers/bottlers";
import Login from './components/features/login/login';
import ProtectedRoute from "./components/features/ProtectedRoute";
import { ServiceDetailPage } from "./components/features/dashboard/serviceDetail";
import ActionPacks from "./components/features/settings/ActionPacks";
import Integrations from "./components/features/settings/Integrations";
import Settings from "./components/features/settings/Settings";
import CorpItKnowledge from "./components/features/corpItKnowledge/CorpItKnowledge";
import RecommendationCenter from "./components/features/recommendationCenter/RecommendationCenter";
import ActionCenter from "./components/features/actionCenter/ActionCenter";
import Announcements from "./components/features/dashboard/pages/Announcements";
import ReviewDashboard from "./components/features/dashboard/pages/ReviewDashboard";
import QBRSharedMaterials from "./components/features/dashboard/pages/QBRSharedMaterials";
import QBRMaterialsDetail from "./components/features/dashboard/pages/QBRMaterialsDetail";
import CSATFolder from "./components/features/dashboard/pages/CSATFolder";
import SAPTroubleshootingFolder from "./components/features/dashboard/pages/SAPTroubleshootingFolder";
import GeneralDocumentsFolder from "./components/features/dashboard/pages/GeneralDocumentsFolder";
import ContactsOnCall from "./components/features/dashboard/pages/ContactsOnCall";
import SubmitSupportRequest from "./components/features/dashboard/pages/SubmitSupportRequest";
import "./styles/globals.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/announcements" element={<Announcements />} />
          <Route path="/dashboard/review-dashboard" element={<ReviewDashboard />} />
          <Route path="/dashboard/qbr" element={<QBRSharedMaterials />} />
          <Route path="/dashboard/qbr/materials" element={<QBRMaterialsDetail />} />
          <Route path="/dashboard/qbr/csat" element={<CSATFolder />} />
          <Route path="/dashboard/qbr/sap-troubleshooting" element={<SAPTroubleshootingFolder />} />
          <Route path="/dashboard/qbr/general-documents" element={<GeneralDocumentsFolder />} />
          <Route path="/dashboard/contacts" element={<ContactsOnCall />} />
          <Route path="/dashboard/submit-request" element={<SubmitSupportRequest />} />
          <Route path="/impactAnalysis" element={<ImpactAnalysis />} />
          <Route path="/bottlers" element={<Bottlers />} />
          <Route path="/service/:serviceKey" element={<ServiceDetailPage />} />
          <Route path="/corp-it-knowledge" element={<CorpItKnowledge />} />
          <Route path="/recommendation-center" element={<RecommendationCenter />} />
          <Route path="/action-center" element={<ActionCenter />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/automation" element={<ActionPacks />} />
          <Route path="/integrations" element={<Integrations />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;